module.exports = __webpack_public_path__ + "static/NationalWeb-Semibold-0359d38dec507ef255a22ba9cea43a2c.woff2";